
import { defineComponent, onMounted, ref } from "vue";
import PosterCard from "../components/PosterCard.vue";
import router from "../router";
import { getTvShows, tvList } from "../functions/useMovieAPI";
import { Show } from "../types";

export default defineComponent({
  name: "TVShows",
  components: {
    PosterCard,
  },
  setup() {
    const selectedMovies = ref<{ [key: number]: Show }>({});

    function handleSelectedTvShow(payload: [number, Show]): void {
      console.log("checked tv", payload[1].id);
      selectedMovies.value[payload[0]] = payload[1];
      router.push({
        path: "/recommendations",
        query: { id: String(payload[1].id), type: "tv" },
      });
    }

    onMounted(() => {
      getTvShows();
    });

    return {
      tvList,
      handleSelectedTvShow,
    };
  },
});
